import {
    Box,
    Button,
    Skeleton,
    Theme,
    Typography,
} from "@mui/material"
import CustomNavChart from "../../../dashboard/chart/CustomNavChart"
import { ErrorText } from "../../../dashboard/chart/CustomeLineChart"
import { IndNavBtnProps, PerformanceProps } from "../types"
import { PerformanceLoading } from "../LoadingComponents"
import InfoToltip from "../../../dashboard/components/InfoToltip"
import PerformanceTooltip from "../../../dashboard/components/PerformanceTooltip"
import { useHistory } from "react-router"

const navChartButtons = [{
    type: 'month',
    count: 6,
    text: '6M'
}, {
    type: 'year',
    count: 1,
    text: '1Y'
},
{
    type: 'all',
    text: 'Inception'
}]

export const Performance = (
    {
        isLoading,
        isSuccess,
        data,
        activeButton,
        onButtonClick
    }: PerformanceProps): JSX.Element => {


    const history = useHistory();
    const { pathname: pathName, state } = history.location
    const initialRouter = pathName.split('/').filter((item: string) => item !== '')

    console.log('initialRouter', initialRouter)

    const tooltipData = [
        ...(data?.label1 ? [{
            title: data?.label1 ?? ""
        }] : []),
        ...(initialRouter[0] === 'product' && data?.label2 ? [{
            title: data?.label2 ?? ""
        }] : []),
        ...(initialRouter[0] === 'product' && data?.label3 ? [{
            title: data?.label3 ?? ""
        }] : []),
        ...(initialRouter[0] === 'product' && data?.label4 ? [{
            title: data?.label4 ?? ""
        }] : []),
        ...(initialRouter[0] === 'product' && data?.label5 ? [{
            title: data?.label5 ?? ""
        }] : [])
    ]



    return (
        <>
            {isLoading && (<PerformanceLoading />)}
            {(!isLoading && !isSuccess) && (
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            paddingBottom: "20px"
                        }}
                    >
                        <Typography
                            variant="h2"
                            sx={(theme: Theme) => ({
                                lineHeight: '25px',
                                letterSpacing: "0.01px",
                                color: theme.palette.text.primary,
                            })}
                        >
                            Portfolio Performance
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            flex: 1,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Typography
                            variant="body_600"
                            sx={(theme: Theme) => ({
                                fontWeight: 500,
                                lineHeight: "22.5px",
                                letterSpacing: "0.01px",
                                color: theme.palette.text.primary,
                                textAlign: "center",
                                width: "100%"
                            })}
                        >
                            Something went wrong. Please try again.
                        </Typography>
                    </Box>
                </Box>

            )}
            {(!isLoading && isSuccess) && (
                <>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        rowGap: '10px',
                        mb: '55px'
                    }}>
                        <Typography
                            variant="h2"
                            color='text.primary'
                        >
                            Portfolio Performance
                        </Typography>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: { sm: 'flex-end', md: 'flex-start' },
                            columnGap: { sm: 0, md: 2, lg: 3 },
                        }}>
                            <Typography
                                component='span'
                                variant="body_500"
                                color="text.primary"
                            >
                                Portfolio Legends
                                <PerformanceTooltip data={tooltipData} />
                            </Typography>
                        </Box>
                    </Box>

                    <Box>
                        <Box sx={{ height: "400px" }}>
                            {(data?.data1?.length === 0 && data?.data2?.length === 0 && data?.data3?.length === 0 && data?.data4?.length === 0 && data?.data5?.length === 0) ? (
                                <ErrorText />
                            ) :
                                <CustomNavChart
                                    data={data?.data1}
                                    data1={initialRouter[0] === 'product' ? data?.data2 : []}
                                    data2={initialRouter[0] === 'product' ? data?.data3 : []}
                                    data3={initialRouter[0] === 'product' ? data?.data4 : []}
                                    data4={initialRouter[0] === 'product' ? data?.data5 : []}
                                    label1={data?.label1 || undefined}
                                    label2={(initialRouter[0] === 'product' ? data?.label2 : '') || undefined}
                                    label3={(initialRouter[0] === 'product' ? data?.label3 : '') || undefined}
                                    label4={(initialRouter[0] === 'product' ? data?.label4 : '') || undefined}
                                    label5={(initialRouter[0] === 'product' ? data?.label5 : '') || undefined}
                                    dynamicY={true}
                                    description="Performance"
                                />
                            }
                        </Box>
                        <Box
                            aria-live="polite"
                            aria-atomic="true"
                            role="status"
                            sx={{
                                position: 'absolute',
                                width: '1px',
                                height: '1px',
                                padding: 0,
                                margin: '-1px',
                                overflow: 'hidden',
                                clip: 'rect(0, 0, 0, 0)',
                                whiteSpace: 'nowrap',
                                border: 0,
                            }}
                        >
                            {activeButton
                                ? `Portfolio performance chart updated. Showing ${activeButton} (${navChartButtons.findIndex(
                                    (btn) => btn?.text === activeButton
                                ) + 1} of ${navChartButtons.length})`
                                : ''}
                        </Box>
                        <Box
                            role="group"
                            aria-label="Portfolio performance time range"
                            sx={{
                                mt: '45px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                columnGap: '10px'
                            }}
                        >
                            {navChartButtons?.map((individualBtn: IndNavBtnProps, index: number) => {
                                return (
                                    <Button
                                        key={index}
                                        sx={(theme: Theme) => ({
                                            ...theme.typography.body_500,
                                            letterSpacing: '0.02px',
                                            borderRadius: '7px',
                                            padding: '5px 15px',
                                            border: 'none',
                                            cursor: 'pointer',
                                            color: { color: activeButton === individualBtn?.text ? theme.palette.common.white : theme.palette.text.secondary },
                                            '&:hover': {
                                                border: 'none',
                                            }
                                        }
                                        )}
                                        variant={activeButton === individualBtn?.text ? 'contained' : 'outlined'}
                                        onClick={() => onButtonClick(individualBtn?.text)}
                                        aria-current={activeButton === individualBtn?.text ? 'true' : undefined}
                                        aria-pressed={activeButton === individualBtn?.text}
                                    >
                                        {individualBtn?.text}
                                    </Button>
                                )
                            })}
                        </Box>
                    </Box>
                </>
            )}
        </>
    )
}